export default {
  name: "Merge",
  methods: {
    merge(...args) {
      let out = undefined;
      for (const i of args) {
        if (i) {
          if (out == undefined) {
            out = i;
          } else {
            out += ` ${i}`;
          }
        }
      }
      return out;
    },
  },
};
